import axios from 'axios';
import { useI18n } from 'vue-i18n';
import type { BuyablesEndpoint, DateSelectionEndpoint, ReserveEndpoint, WorkspacesEndpoint } from './api/resources';

export function useApi() {
	const i18n = useI18n();

	const client = axios.create({
		baseURL: import.meta.env.VITE_API_URL,
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			'Accept-Language': i18n.locale.value,
		},
		timeout: 10000,
	});

	const reserve = {
		get: (workspaceId: number) => client.get<ReserveEndpoint>(`/web/workspaces/${workspaceId}/reserve`),
	};

	const product = {
		get: (productId: number, entity: string, date?: string) =>
			client.get(`/web/productinfo/${entity}/${productId}`, { params: { date } }),
	};

	const calendar = {
		get: (workspaceId: number, month: number, year: number) =>
			client.get(`/web/workspaces/${workspaceId}/default-product/calendar/${month}/${year}`),
	};

	const workspaces = {
		get: () => client.get<WorkspacesEndpoint>('/web/workspaces'),
		getDateSelectionData: (workspaceId: number) =>
			client.get<DateSelectionEndpoint>(`/web/workspaces/${workspaceId}/date-selection`),
		getBuyables: (workspaceId: number, productSetId: string, params: { [key: string]: string } = {}) =>
			client.get<BuyablesEndpoint>(`/web/workspaces/${workspaceId}/product-sets/${productSetId}/buyables`, { params }),
		getBuyablesForDate: (
			workspaceId: number,
			productSetId: string,
			date: string,
			params: { [key: string]: string } = {},
		) =>
			client.get<BuyablesEndpoint>(
				`/web/workspaces/${workspaceId}/product-sets/${productSetId}/available/${date}/buyables`,
				{ params },
			),
		checkVouchers: (workspaceId: number, voucher_codes: string[], client_ip: string | null) =>
			client.post(`/web/workspaces/${workspaceId}/vouchers/valid`, { voucher_codes, client_ip }),
	};

	return {
		reserve,
		product,
		calendar,
		workspaces,
	};
}
